import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/offers/$username/$primarySorting/')({
    ...firstLevelIndexRoute("/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});
